import { useMemo } from "react";
import { getModuleRoute } from "../utils/moduleRoutes";

const DEFAULT_RIGHTS = {
  can_add: false,
  can_edit: false,
  can_delete: false,
  can_view: false,
  can_print: false,
  can_approve: false,
};

/**
 * Hook to get user permissions for a specific menu
 * @param {string} menuCode - The menu code to check permissions for
 * @returns {Object} User rights object
 */
export const usePermissions = (menuCode) => {
  return useMemo(() => {
    if (!menuCode) return DEFAULT_RIGHTS;

    try {
      const menuControls = JSON.parse(localStorage.getItem("sidebarItems") || "[]");
      
      for (const menu of menuControls) {
        const isModule = !!getModuleRoute({ menu_code: menuCode });
        if (isModule && String(menu.status).toLowerCase() !== "active") continue;
        const childMenu = menu.child_menu?.find(
          (child) => child.menu_code === menuCode && (!isModule || String(child.status).toLowerCase() === "active")
        );
        if (childMenu?.rights) {
          if (isModule) {
            return Object.fromEntries(Object.keys(DEFAULT_RIGHTS).map((right) => [right, childMenu.rights[right] === true]));
          }
          return childMenu.rights;
        }
      }
    } catch (error) {
      console.error("Error parsing menu controls:", error);
    }

    return DEFAULT_RIGHTS;
  }, [menuCode]);
};
